import * as React from 'react';
import { IconChevronLeft16, UIText1 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrevQuestionButton = function PrevQuestionButton(props) {
  var onPrevStep = props.onPrevStep,
    isFirstStep = props.isFirstStep;
  if (isFirstStep) {
    return null;
  }
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    onClick: onPrevStep,
    className: styles['button'],
    "data-testid": "prevQ",
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(IconChevronLeft16, {
        color: 'current_color',
        display: 'block'
      })
    }), /*#__PURE__*/_jsx(UIText1, {
      color: 'current_color',
      display: "inline",
      children: "\u041D\u0430\u0437\u0430\u0434"
    })]
  });
};
PrevQuestionButton.displayName = 'PrevQuestionButton';